/* eslint-disable react/require-default-props */
import React from 'react';
import AssigneeMultiSelect from '@components/Multiselects/AssigneeMultiselect';
import { AssigneeType } from '@enums/assignee-type.enum';
function AssigneeSelector({ selectedTechnicianId, selectedSubcontractorId, assigneeType, readOnly = false, fullWidth = false, forInspections = false, buildingId }) {
    const initialTechnicianIds = assigneeType === AssigneeType.TECHNICIAN ? [selectedTechnicianId] : [];
    const initialSubcontractorIds = assigneeType === AssigneeType.SUBCONTRACTOR ? [selectedSubcontractorId] : [];
    const [currentTechnicianIds, setCurrentTechnicianIds] = React.useState(initialTechnicianIds);
    const [currentSubcontractorIds, setCurrentSubcontractorIds] = React.useState(initialSubcontractorIds);
    const handleTechnicianChange = React.useCallback((selections) => {
        const technicianField = document.getElementById('assignee_selector_technician_id');
        const assigneeTypeField = document.getElementById('assignee_selector_assignee_type');
        const subcontractorField = document.getElementById('assignee_selector_subcontractor_id');
        if (!technicianField || !assigneeTypeField || !subcontractorField) {
            console.error('Hidden fields not found');
            return;
        }
        subcontractorField.value = '';
        assigneeTypeField.value = AssigneeType.TECHNICIAN;
        if (selections.length > 0 && selections[0] !== null) {
            technicianField.value = String(selections[0]);
        }
        else {
            technicianField.value = '';
        }
        setCurrentSubcontractorIds([]);
        setCurrentTechnicianIds([selections[0]]);
        assigneeTypeField.dispatchEvent(new Event('change'));
    }, []);
    const handleSubcontractorChange = React.useCallback((selections) => {
        const technicianField = document.getElementById('assignee_selector_technician_id');
        const assigneeTypeField = document.getElementById('assignee_selector_assignee_type');
        const subcontractorField = document.getElementById('assignee_selector_subcontractor_id');
        if (!technicianField || !assigneeTypeField || !subcontractorField) {
            console.error('Hidden fields not found');
            return;
        }
        technicianField.value = '';
        assigneeTypeField.value = AssigneeType.SUBCONTRACTOR;
        if (selections.length > 0 && selections[0] !== null) {
            subcontractorField.value = String(selections[0]);
        }
        else {
            subcontractorField.value = '';
        }
        setCurrentTechnicianIds([]);
        setCurrentSubcontractorIds([selections[0]]);
        assigneeTypeField.dispatchEvent(new Event('change'));
    }, []);
    return (React.createElement(AssigneeMultiSelect
    // eslint-disable-next-line react/style-prop-object
    , { 
        // eslint-disable-next-line react/style-prop-object
        style: "inline-edit", selectedTechnicianIds: currentTechnicianIds, selectedSubcontractorIds: currentSubcontractorIds, teamIds: null, onTechChange: handleTechnicianChange, onSubChange: handleSubcontractorChange, readOnly: readOnly, fullWidth: fullWidth, single: true, forInspections: forInspections, buildingId: buildingId }));
}
export default AssigneeSelector;
